import {AfterViewInit, Component, ElementRef, ViewChild, HostListener} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {ActivatedRoute} from '@angular/router';
import {plainToClass} from 'class-transformer';

import {environment} from 'environments/environment';

import {ConstantsService} from 'app/services/constants-service';

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html'
})

export class ContentComponent {
  // As this value is being formed based on dynamic content, so we are
  // defining type as any. In these cases, we want to opt-out of
  // type-checking and let the values pass through compile-time checks.
  @ViewChild('iFrame') iFrame: ElementRef;
  @ViewChild('iFrameParent') iFrameParent: ElementRef;

  homeIFrameUrl: any;
  subscription: any;

  constructor(private route: ActivatedRoute,
              private domSanitizer: DomSanitizer) {
    // Set the default Iframe URL
    // TODO: BASE_API_HOME_URL this should be checked running in order to assert that the correct behavior keeps after the changes.
    this.subscription = this.route
      .queryParams
      .subscribe(params => {
        if (params.hasOwnProperty('paramIframeUrl')) {
          this.homeIFrameUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(params['paramIframeUrl']);
        } else if (params.hasOwnProperty('iframeUrl')) {
          this.homeIFrameUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(
            ConstantsService.APP_HOME_URL + params['iframeUrl']);
        }
      });
  }

  onIframeLoad() {
    this.resizeIframe();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.resizeIframe();
  }

  resizeIframe() {
    const windowHeight = window.innerHeight;

    // uncomment for tabs support
    // this.iFrame.nativeElement.height = windowHeight - (this.isPerson ? 460 : 410);
    if (this.iFrameParent) {
      this.iFrameParent.nativeElement.style.height = windowHeight+"px";
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/clients/client/content/content.component.ts